var Marionette = require('marionette');
var Entities = require('Entities'); 
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;

var Quicklink = Marionette.View.extend({
    tagName: "li",
    events: {
        'click @ui.quicklink': 'navigate'
    },
    template: '#gclPendingActionQuicklink',
    ui: {
        count: '#count',
        quicklink: '#gclLink'
    },
    navigate: function () {
        window.open(EY.Consultation.GclWeb, "_blank");
    },
    onRender: function () {
        this.ui.count.html(this.options.count);
    }
});

var Filter = {
    $or: [{ assignedTo: User.upn },
    {
        $and: [
            // Show if 
            // 1. RecordType is 'RequiredNotification' and
            // 2. StatusType is 'UsersNotified' and
            // 3. you're listed in any approver field under ToBeNotified section
            { recordTypeId: "RecordType_RequiredNotification" },
            {
                statusTypeId: { $eq: StatusType.UsersNotified },
                approvers: {
                    $elemMatch:
                    {
                        upn: User.upn,
                        acknowledgeStatus: '',
                        acknowledgeDate: ''
                    }
                }
            },
        ]
    }]
};

module.exports.show = function (options) {
    var region = options.region;

    var gclRecords = new Entities.GclRecords();

    gclRecords.fetch({ 
        aggregate: [{
            $match: { $or: [Filter] }
        }]
    }).done(function () {
        if (gclRecords.length > 0) {
            var pendingRecords = gclRecords.length;
            var count = pendingRecords > 0 ? pendingRecords : 0;
            if (gclRecords.length > 0) {
                region.show(new Quicklink({ count: count }));
            }
        }
        });

};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeGclQuicklink.js